module.exports = __webpack_public_path__ + "media/images/front/event/company-icon-306573ceb92e5949d61c92447a9bd63a.svg";